export const NAVBAR_STATE_CHANGE = "NAVBAR_STATE_CHANGE";

export const changeNavbarState = (element) => ({
  type: NAVBAR_STATE_CHANGE,
  payload: element,
});
